import { memo } from "react";
import { classNames } from "helpers";

// Isti primitivi kao na detalju oglasa (ListingSpecification) — sekcije odvojene
// crtom, sitan uppercase naslov i read-only kartice s vrijednostima.
export const Section: React.FC<{ title: string; children: React.ReactNode }> = memo(
  ({ title, children }) => (
    <div className="border-b border-slate-200 pt-4 px-4 pb-2">
      <div className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-3">{title}</div>
      {children}
    </div>
  )
);

export const InfoCard: React.FC<{
  label: string;
  value: React.ReactNode;
  colSpan?: 1 | 2;
}> = memo(({ label, value, colSpan }) => (
  <div
    className={classNames(
      "border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]",
      colSpan === 2 ? "col-span-2" : ""
    )}
  >
    <div className="text-sm text-slate-600">{label}</div>
    <div className="text-md font-medium text-slate-800 truncate">
      {value == null || value === "" ? "-" : value}
    </div>
  </div>
));

export const InfoGrid: React.FC<{
  columns?: 2 | 3 | 4;
  children: React.ReactNode;
}> = memo(({ columns = 3, children }) => {
  const cls = columns === 2 ? "grid-cols-2" : columns === 3 ? "grid-cols-3" : "grid-cols-4";
  return <div className={classNames("grid gap-3 mb-3", cls)}>{children}</div>;
});
